<template>
  <div class="flex items-center gap-2">
    <WLIcon
      :name="iconName || IconName.FILLED_WARNING"
      :size="IconSize.SMALL"
      class="flex-shrink-0"
    />
    <div class="grow">
      <slot name="message">
        <p class="font-regular inline w-full text-start text-sm">
          {{ message }}
        </p>
        <span class="inline pl-1">
          <slot name="button"></slot>
        </span>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconName, IconSize, WLIcon } from "../icon";
import type { BannerListItemProps } from "./types";

const { iconName, message } = defineProps<BannerListItemProps>();
</script>
